 
const reducer = (state = [], action) => {
    switch (action.type) {
        case "getResources":
            return action.payload;
        default:
            return state;
     }
}

export default reducer;